import { ADD_NEW_USER_SUCCESS, UPDATE_NEW_USER_SUCCESS, USER_DATA_ERROR, USER_DATA_SUCCESS, ALL_USER_DATA_SUCCESS, DELETE_USER_BYID, DELETE_USER_SUCCESS, DELETE_USER_ERROR,USER_ROLE,USER_ROLE_SUCCESS } from "./actiontype"


const initialState = {
  newUser: null,
  updateUser: null,
  //loading: false,
  //userDeleted: false,
}

const getuserData = (state = initialState, action) => {
  switch (action.type) {
    case USER_DATA_SUCCESS:
      state = {
        ...state,
        userlist: action.payload.userData,
        totalCount: action.payload.totalCount,
        userlistError: null,
      }
      break
      case USER_ROLE:
        state = {
          ...state,
          allRolelist: action.payload,
          sitelistError: null,
        }
        break;
      case USER_ROLE_SUCCESS:
        state = {
          ...state,
          getrole: action.payload,
          userlistError: null,
        }
        break;
    case ALL_USER_DATA_SUCCESS:
      state = {
        ...state,
        alluserslist: action.payload,
        userlistError: null,
      }
      break

    case USER_DATA_ERROR:
      state = { ...state, userlistError: action.payload }
      break
    case ADD_NEW_USER_SUCCESS:
      state = { ...state, newUser: action.payload }
      break
    case UPDATE_NEW_USER_SUCCESS:
      state = { ...state, updateUser: action.payload }
      break
    case DELETE_USER_BYID:
      state = {
        ...state, loading: false,
      };
      break;
    case DELETE_USER_SUCCESS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_USER_ERROR:
      state = { ...state, userDeleted: false, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state
}

export default getuserData
